import { formatearImporte } from '../../../nucleo/importes/formatoDeImporte.js';

/**
 * LAS CIFRAS QUE SÍ SE SABEN DE UN RENGLÓN SIN ESTADO
 * (incremento 18/21 · RN-702, matizada por D-396 · CA-18-29).
 *
 * CUÁNDO APARECE: solo cuando no se pudo comprobar cuánto de la deuda está en
 * compras a meses. En ese caso el renglón sigue SIN ESTADO —deducir uno contra la
 * deuda al corte repintaría la «vencida» en falso que este incremento elimina—
 * pero el saldo al corte y lo que la persona declaró a meses sí se saben, y
 * ocultarlos sería esconder datos ciertos.
 *
 * CUÁNDO NO APARECE: cuando lo que falló fue el saldo o los pagos. Ahí no viaja
 * ninguna de las dos cifras y este bloque no pinta nada, así que el renglón queda
 * EXACTAMENTE como estaba antes de este incremento.
 *
 * EL CONDICIONAL ES LA PIEZA: `== null` y no un `if (!cifra)`, porque un saldo al
 * corte de 0.00 es un dato cierto que sí hay que enseñar; lo que no se sabe llega
 * nulo. Confundirlos dejaría la última frase del aviso —«las demás cifras del
 * renglón son correctas»— hablando de cifras que nadie ve.
 *
 * NO SUMA NI RESTA NADA (RNF-059): pinta lo que llegó del servidor.
 */
export function CifrasQueSiSeSaben({ tarjeta, datoDePrueba = 'cifras-que-si-se-saben' }) {
  const saldoAlCorte = tarjeta?.importeSaldoAlCorte;
  const declarado = tarjeta?.importeDiferidoDeclarado;

  if (saldoAlCorte == null && declarado == null) return null;

  const iso = tarjeta.codigoISO;

  return (
    <div className="msi" data-prueba={datoDePrueba}>
      <div className="msi-t">Esto sí lo sabemos</div>

      {saldoAlCorte != null && (
        <div className="fila">
          <span className="crece">Deuda acumulada al corte</span>
          <b data-prueba="cifra-cierta-saldo-al-corte">{formatearImporte(saldoAlCorte, iso)}</b>
        </div>
      )}
      {declarado != null && (
        <div className="fila">
          <span className="crece">Compras a meses que declaraste</span>
          <b data-prueba="cifra-cierta-diferido-declarado">{formatearImporte(declarado, iso)}</b>
        </div>
      )}
    </div>
  );
}
